const applyScrollShadow = (wrapper) => {
  if (wrapper.dataset.bpTableScroll) return;
  wrapper.dataset.bpTableScroll = "1";

  const container = document.createElement("div");
  container.className = "bp-table-scroll";
  wrapper.parentNode.insertBefore(container, wrapper);
  container.appendChild(wrapper);

  const shadowLeft = document.createElement("div");
  shadowLeft.className =
    "bp-table-scroll__shadow bp-table-scroll__shadow--left";
  const shadowRight = document.createElement("div");
  shadowRight.className =
    "bp-table-scroll__shadow bp-table-scroll__shadow--right";
  container.appendChild(shadowLeft);
  container.appendChild(shadowRight);

  const update = () => {
    const atLeft = wrapper.scrollLeft > 0;
    const atRight =
      wrapper.scrollLeft < wrapper.scrollWidth - wrapper.clientWidth - 1;
    container.classList.toggle("bp-table-scroll--left", atLeft);
    container.classList.toggle("bp-table-scroll--right", atRight);
  };

  wrapper.addEventListener("scroll", update, { passive: true });
  new ResizeObserver(update).observe(wrapper);
  update();
};

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof Element)) continue;
      if (node.classList.contains("rte-table-wrapper")) {
        applyScrollShadow(node);
      }
      node.querySelectorAll(".rte-table-wrapper").forEach(applyScrollShadow);
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });

document
  .querySelectorAll(".default-blog .rte-table-wrapper")
  .forEach(applyScrollShadow);
